import { render, staticRenderFns } from "./QiangLiJuCaiLabelDialog.vue?vue&type=template&id=1c0b1205&scoped=true"
import script from "./QiangLiJuCaiLabelDialog.vue?vue&type=script&lang=js"
export * from "./QiangLiJuCaiLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./QiangLiJuCaiLabelDialog.vue?vue&type=style&index=0&id=1c0b1205&prod&scoped=true&lang=css"
import style1 from "./QiangLiJuCaiLabelDialog.vue?vue&type=style&index=1&id=1c0b1205&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b1205",
  null
  
)

export default component.exports